import * as React from 'react';
import { defaultMemoize } from 'reselect';
import * as _ from 'underscore';

import { BreadcrumbStateInfo } from '~src/app/content/breadcrumbs/BreadcrumbStateInfo';
import { SpaceInfo, SubspaceName } from '~src/app/state/SpaceInfo';
import { Messages } from '~src/codegen/Localize';

import { SpaceHeaderWithTotalItemsCount } from '../../Header/SpaceHeaderWithTotalItemsCount';
import { AllSiteUsersSpace } from '../../SiteUsersSpace/AllSiteUsersSpace';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';
import { Subspace, TabbedSpace } from '../../TabbedSpace';
import { AllUserIdentitiesSubspace } from '../AllUserIdentitiesSubspace';

export interface AllSiteUsersAndIdentitiesSpaceOwnProps {
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
}

export interface AllSiteUsersAndIdentitiesSpaceStateProps {
  readonly spaceInfo: SpaceInfo;
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedUsers: number;

  readonly isSessionMultiSite: boolean;
  readonly isSessionServerAdmin: boolean;
  readonly canSessionUserManageUsers: boolean;
}

export interface AllSiteUsersAndIdentitiesSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly updateBreadcrumbs: (breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>) => void;
}

export type AllSiteUsersAndIdentitiesSpaceProps = AllSiteUsersAndIdentitiesSpaceOwnProps & AllSiteUsersAndIdentitiesSpaceStateProps & AllSiteUsersAndIdentitiesSpaceDispatchProps;

export class AllSiteUsersAndIdentitiesSpace extends React.PureComponent<AllSiteUsersAndIdentitiesSpaceProps> {
  private memoizedGetSiteUsersSubspaces = defaultMemoize(getAllSiteUsersSubspaces);

  public constructor(props: AllSiteUsersAndIdentitiesSpaceProps) {
    super(props);
  }

  public componentDidMount() {
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    const header = <SpaceHeaderWithTotalItemsCount
      label={Messages.users()}
      testId={'site-users'}
      count={this.props.numberOfFetchedUsers}
      onClick={null}
      countUpToDate={!this.props.isBusyFetchingItems}
    />;
    const subspaces = this.memoizedGetSiteUsersSubspaces(this.props);
    return (
      <TabbedSpace
        subspaces={subspaces}
        activeSubspaceName={this.props.spaceInfo.subspaceName}
        urlForSubspace={x => this.getSubspaceUrls(x)}
        mastheadElement={header}
        testIdPrefix={'all-users-and-identities-tabbed-space'}
        spaceItemName={''}
      />
    );
  }

  private getSubspaceUrls(subspaceName?: SubspaceName): string {
    if (subspaceName === 'list') {
      return this.props.urls.usersUrl();
    } else if (subspaceName === 'identities') {
      return this.props.urls.allUserIdentitiesUrl();
    } else {
      return '';
    }
  }
}

function getAllSiteUsersSubspaces(props: AllSiteUsersAndIdentitiesSpaceProps): ReadonlyArray<Subspace> {
  return _.compact([
    {
      name: 'list',
      tabLabel: Messages.userList(),
      shouldRenderTabContentCount: false,
      renderContent: () => (<AllSiteUsersSpace {...props} shouldRenderAsSubspace={true} />)
    },
    {
      name: 'identities',
      tabLabel: Messages.identityMigration(),
      shouldRenderTabContentCount: false,
      renderContent: () => (<AllUserIdentitiesSubspace {...props} subspaceHref={props.urls.allUserIdentitiesUrl()}/>)
    },
  ]);
}
